export function Card({ children }) {
    return (
      <div className="bg-white shadow rounded-lg p-4">
        {children}
      </div>
    )
  }
  
  export function CardHeader({ children }) {
    return <div className="mb-4">{children}</div>
  }
  
  export function CardTitle({ children, className = '' }) {
    return <h2 className={`text-xl font-semibold ${className}`}>{children}</h2>
  }
  
  export function CardDescription({ children }) {
    return <p className="text-sm text-gray-500">{children}</p>
  }
  
  export function CardContent({ children }) {
    return <div>{children}</div>
  }

  